export default {
    name: 'geral',
    data() {
        return{
            retorno:[],
            respostaJSON: []
        }
    },
    agora(formato){
        return this.dateTimeFormatar(new Date(),formato);
    },
    dataPadrao(datap) {
        if (datap == "") return "";
        if (datap == undefined) return "";
        var sp = datap.substring(0, 10).split("-");
        return this.dateTimeFormatar(new Date(sp[0], sp[1] - 1, sp[2]), "dd/MM/yyyy");
    },
    dataCurta(data, separador, invertida) {

        return (this.ehData(data, separador, invertida)?this.dataFormatar(data,separador,invertida,true):"");

    },
    dataeHora(data) {
        if (data == "") return "";
        var sp = data.substring(0, 10).split("-");
        var tm = data.substring(11, 19).split(":");
        return this.dateTimeFormatar(new Date(sp[0], sp[1] - 1, sp[2], tm[0], tm[1], tm[2], 0), "dd/MM/yyyy HH:mm:ss");
    },
    dataeHoraCurta(data) {
        if (data == "") return "";
        var sp = data.substring(0, 10).split("-");
        var tm = data.substring(11, 19).split(":");
        var d = new Date(sp[0], sp[1] - 1, sp[2], tm[0], tm[1], tm[2], 0);
        return this.dateTimeFormatar(d,"dd/MM/yy HH:mm");

    },
    dataReferencia(data) {

        if (data == "") return "";
        var sp = data.substring(0, 10).split("-");
        var s = sp[1] + "/" + sp[0];
        return (s === "01/1900" ? "" : s);

    },
    dataFormatar(data, separador, invertida,curta) {

        let d = data.split(' ')[0];
        d = d.split('T')[0];
        if (d.length==0){
            return "";
        }
        let dia =0;
        let mes = 0;
        let ano=0;
        let sep = (separador==""?"/":separador);
        if (invertida == true){
            d = d.split(sep);
            ano=parseInt(d[0]);
            mes=parseInt(d[1]);
            dia=parseInt(d[2]);
        }
        else{
            d = d.split(sep);
            ano=parseInt(d[2]);
            mes=parseInt(d[1]);
            dia=parseInt(d[0]);
        }

        return ((dia.toString().length==2?"":"0")+dia)+"/"+((mes.toString().length==2?"":"0")+mes)+"/"+(curta?(ano.toString().length==2?ano.toString():ano.toString().substr(2,2)):ano.toString().length==4?ano.toString():(2000+ano).toString());
    },

    ehData(data,separador,invertida){
        let d = data.split(' ')[0];
        d = d.split('T')[0];

        if (d.length==0){
            return false;
        }
        let dia =0;
        let mes = 0;
        let ano=0;
        let sep = (separador==""?"/":separador);
        if (invertida == true){
            d = d.split(sep);
            ano=parseInt(d[0]);
            mes=parseInt(d[1]);
            dia=parseInt(d[2]);
        }
        else{
            d = d.split(sep);
            ano=parseInt(d[2]);
            mes=parseInt(d[1]);
            dia=parseInt(d[0]);
        }
        let bissexto = false;
        bissexto = (ano%4 == 0 && ano%100 > 0 ? true : (ano%400 == 0 ?true: false));

        let valido = false;
        valido = (mes>=1 && mes<=12);
        if (valido && mes<8){
            valido = false;
            if (mes%2==1){
                valido = (dia>=1 && dia<=31);
            }
            else {
                if (mes == 2){
                    valido = (bissexto?(dia>=1 && dia<=29):(dia>=1 && dia<=28)); 
                }
                else{
                    valido = (dia>=1 && dia<=30);
                }
            }
        }
        if (valido && mes>7){
            valido = false;
            valido =((mes%2==0)?(dia>=1 && dia<=31):(dia>=1 && dia<=30));
        }
        return valido;
    },
    ehNumero(str){
        return !isNaN(parseFloat(str))
    },
    ehInteiro(str){
        return !isNaN(parseInt(str))
    },
    formatarCNPJ(cnpj){
        if (cnpj.length<14){
          cnpj = "0".repeat(14-cnpj.length) + cnpj;
        }
      var s = '-' + cnpj.substr(cnpj.length-2,2);  
      s = '/' + cnpj.substr(cnpj.length-6,4) + s;
      s = '.' + cnpj.substr(cnpj.length-9,3) + s;
      s = '.' + cnpj.substr(cnpj.length-12,3) + s;
      s = cnpj.substr(cnpj.length-14,2) + s;
      return s;
    },
    formatarCPF(cpf){
        if (cpf.length<11){
          cpf = "0".repeat(11-cpf.length) + cpf;
        }
      var s = '-' + cpf.substr(cpf.length-2,2);  
      s = '.' + cpf.substr(cpf.length-5,3) + s;
      s = '.' + cpf.substr(cpf.length-8,3) + s;
      s = cpf.substr(cpf.length-11,3) + s;
      return s;
    },
    formatarF(numero, casas){
        //return (parseFloat(numero.toString()).toFixed((casas==undefined?2:casas))).toLocaleString();
        return parseFloat(numero.toString()).toLocaleString('pt-br',{'minimumFractionDigits':(casas==undefined?2:casas), 'maximumFractionDigits':(casas==undefined?2:casas)});
    },
    formatarI(numero){
        return parseInt(numero.toString()).toLocaleString();
    },
    gerarToken(raiz) {
        var dataMarco = new Date(2018, 0, 1);
        var t = dataMarco.getTime();

        var agora = new Date();
        var a = agora.getTime();

        var span = a - t;

        var z = Math.round(Math.random() * 100);

        var w = (span * 100) + z;

        w = 1000000000000000 + w

        return raiz.toString() + w.toString().substr(1);

    },
    titleCase(str) {
        return str.toLowerCase().split(' ').map(function(word) {
          return (word.charAt(0).toUpperCase() + word.slice(1));
        }).join(' ');
    },
    codificarAlfa(param) {
        var criptografado = "";
        var emascii = param.split("");

        var caracter = 0;
        var desl = 0;
        var tipo = "a";
        var crescente = true;
        var salto = Math.floor(Math.random() * (12 - 1 + 1)) + 1;

        criptografado = (String.fromCharCode(77 + salto));

        if (salto < 6) {
            criptografado += "D";
            crescente = false;
        }
        else { criptografado += "C"; }

        for (var i = 0; i < emascii.length; i++) {

            caracter = emascii[i].charCodeAt(0);
            if (32 <= caracter && caracter <= 47) {
                if (tipo != "e") { criptografado += "e"; }
                tipo = "e";
                desl = caracter - 32;
            }
            else if (48 <= caracter && caracter <= 57) {
                if (tipo != "n") { criptografado += "n"; }
                tipo = "n";
                desl = caracter - 48;
            }
            else if (58 <= caracter && caracter <= 64) {
                if (tipo != "s") { criptografado += "s"; }
                tipo = "s";
                desl = caracter - 58;
            }
            else if (65 <= caracter && caracter <= 90) {
                if (tipo != "a") { criptografado += "a"; }
                tipo = "a";
                desl = caracter - 65;
            }
            else if (91 <= caracter && caracter <= 96) {
                if (tipo != "p") { criptografado += "p"; }
                tipo = "p";
                desl = caracter - 91;
            }
            else if (97 <= caracter && caracter <= 122) {
                if (tipo != "m") { criptografado += "m"; }
                tipo = "m";
                desl = caracter - 97;
            }
            else if (123 <= caracter && caracter <= 127) {
                if (tipo != "c") { criptografado += "c"; }
                tipo = "c";
                desl = caracter - 123;
            }
            // Caracteres especiais acime de 128
            else if (128 <= caracter && caracter <= 160) {
                if (tipo != "z") criptografado += "z";
                tipo = "z";
                desl = caracter - 128;
            }
            else if (161 <= caracter && caracter <= 193) {
                if (tipo != "w") criptografado += "w";
                tipo = "w";
                desl = caracter - 161;
            }
            else if (194 <= caracter && caracter <= 226) {
                if (tipo != "y") criptografado += "y";
                tipo = "y";
                desl = caracter - 194;
            }
            else if (227 <= caracter && caracter <= 255) {
                if (tipo != "k") criptografado += "k";
                tipo = "k";
                desl = caracter - 227;
            }
            else {
                if (tipo != "e") { criptografado += "e"; }
                tipo = "e";
                criptografado += String.fromCharCode(caracter);
                desl = -1;
            }

            if (desl >= 0) {
                if ((desl + salto + 65) > 90) {
                    desl -= salto;
                    criptografado += "o";
                }
                else { desl += salto; }

                criptografado += (String.fromCharCode(desl + 65));
            }

            if (caracter == 32) {
                salto = Math.floor(Math.random() * (12 - 1 + 1)) + 1;
                criptografado += (String.fromCharCode(77 + salto));
            }
            if (crescente) {
                salto++;
                if (salto > 11) { crescente = false; }
            }
            else {
                salto--;
                if (salto < 2) { crescente = true; }
            }
        }
        return criptografado;
    },
    decodificarAlfa(param){
        
        var decodificado = "";
        var desl = 0;
        var inicio = 65;
        var overflow = false;
        var tipos = ["a", "m", "n", "e", "s", "p", "c", "z", "w", "y", "k"];
        var inicios = [65, 97, 48, 32, 58, 91, 123, 128, 161, 194, 227];

        if (param.length < 3) return decodificado;

        var emascii = param.split().join(",");
        var salto = emascii.charCodeAt(0) - 77;
        var crescente = (emascii[1] == "C" ? true : false);
        var tipo = "a";
        var tipocorrente = "a";

        for (var i = 2; i < emascii.length; i++) {

            if (emascii.charCodeAt(i) > 90) {

                if (emascii[i] == 'o')
                    overflow = true;
                else
                    tipo = emascii[i];

                continue;
            }

            if (tipo != tipocorrente) {
                for (var z = 0; z < tipos.length; z++) {
                    if (tipos[z] == tipo) {
                        inicio = inicios[z];
                        break;
                    }
                }
                tipocorrente = tipo;
            }
            desl = emascii.charCodeAt(i);
            if (overflow) {
                decodificado += (String.fromCharCode(inicio + desl + salto - 65));
            }
            else {
                decodificado += (String.fromCharCode(inicio + desl - salto - 65));
            }
            overflow = false;

            if (tipo == "e") {
                if ((String.fromCharCode(32 + desl - salto - 65)) == " ") {
                    salto = emascii.charCodeAt(++i) - 77;
                }
            }


            if (crescente) {
                salto++;
                if (salto > 11) crescente = false;
            }
            else {
                salto--;
                if (salto < 2) crescente = true;
            }

        }

        return decodificado;

    },

}
